import axios from 'axios';
import authHeader from '../../auth-header';
import baseUrl from '../../base-url';

const API_URL = baseUrl() + "/api/all/";
const getRiwayatRpl = 'riwayat-peserta/rpl/detail'
const getRiwayatSertifikasi = 'riwayat-peserta/sertifikasi/detail';
const getRiwayatPesertaPelatihan = 'data-pelatihan-peserta/user/';

class RiwayatPesertaService {

    getRiwayatRpl(pageNo, pageSize, filter, idUser) {
        return axios.get(API_URL + getRiwayatRpl, {
            params: {
                pageNo,
                pageSize,
                filter,
                idUser
            },
            headers: authHeader()
        });        
    }   

    getRiwayatSertifikasi(pageNo, pageSize, filter, idUser) {
        return axios.get(API_URL + getRiwayatSertifikasi, {
            params: {
                pageNo,
                pageSize,
                filter,
                idUser
            },
            headers: authHeader()
        });        
    }   
    getRiwayatPesertaPelatihan(idUser) {
        return axios.get(API_URL + getRiwayatPesertaPelatihan + idUser, {            
            headers: authHeader()
        });        
    }    

}

export default new RiwayatPesertaService();